import React, { Component } from 'react'
import { HashRouter, Route, Switch, Link } from 'react-router-dom'

import HomePage from './pages/HomePage'      // Exp 3
import UserPage from './pages/UserPage'      // Exp 3
// import Register from './Register'         // Exp 4 (now replaced by the full registration form)
import Login from './Login'                  // Exp 4

// ----- Exp 3 version (only two routes) -----
// export default function App() {
//   return (
//     <Switch>
//       <Route exact path="/" component={HomePage} />
//       <Route path="/:id" component={UserPage} />
//     </Switch>
//   )
// }

// ----- Exp 4 version (function component, BrowserRouter was in index.js) -----
// export default function App() {
//   return (
//     <div>
//       <header className="header">
//         <h2>Bloomberg Terminal</h2>
//         <ul>
//           <li><Link to="/">Home</Link></li>
//           {/* Register = my full HTML form (Exp 1, 2, 7), so a normal <a> link */}
//           <li><a href="/form/">Register</a></li>
//           <li><Link to="/login">Login</Link></li>
//           {/* Exp 8 payment page */}
//           <li><a href="/form/payment.html">Buy Plan</a></li>
//         </ul>
//       </header>
//
//       <Switch>
//         <Route exact path="/" component={HomePage} />
//         {/* <Route path="/register" component={Register} />   Exp 4 short register, replaced by /form/ */}
//         <Route path="/login" component={Login} />
//         <Route path="/user/:id" component={UserPage} />
//       </Switch>
//
//       <footer className="footer">
//         <p>&copy; 2026 Bloomberg Terminal Student Project (not the real Bloomberg)</p>
//       </footer>
//     </div>
//   )
// }

// ----- Exp 9 version: HashRouter so a page refresh does not give 404 on GitHub Pages -----
class App extends Component {
  render() {
    return (
      <HashRouter basename="/">
        <div>
          <header className="header">
            <h2>Bloomberg Terminal</h2>
            <ul>
              <li><Link to="/">Home</Link></li>
              {/* Register = my full HTML form (Exp 1, 2, 7), so a normal <a> link */}
              <li><a href="/form/">Register</a></li>
              <li><Link to="/login">Login</Link></li>
              {/* Exp 8 payment page */}
              <li><a href="/form/payment.html">Buy Plan</a></li>
            </ul>
          </header>

          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route path="/login" component={Login} />
            <Route path="/user/:id" component={UserPage} />
          </Switch>

          <footer className="footer">
            <p>&copy; 2026 Bloomberg Terminal Student Project (not the real Bloomberg)</p>
          </footer>
        </div>
      </HashRouter>
    )
  }
}

export default App
